// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import axios from 'axios'
import qs from 'qs'
import './assets/css.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import WeVue from 'we-vue'
import 'we-vue/lib/style.css'
import { Toast , Dialog} from 'we-vue'
import $ from 'jquery'
import dayjs from 'dayjs'
import Cookies from 'js-cookie'
import rem from './assets/rem.js'
import './assets/style_fee.css'

import Vant from 'vant'
import { Lazyload } from 'vant';
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css'
Vue.use(Vant)
Vue.use(Lazyload, {
	lazyComponent: true,
	loading: '',
})

const debuginfo = {
	debuging:false//是否为本地调试模式
};


Vue.use(WeVue)
const query = qs.parse(location.hash.substring(3))
const skin = 'ios'

Vue.use(VueAwesomeSwiper)
import { DatetimePicker } from 'we-vue'
Vue.use(DatetimePicker)
//router.beforeEach((to, from, next) => {})

axios.defaults.withCredentials=true
axios.defaults.crossDomain=true
axios.defaults.timeout = 15000;                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';        //配置请求头
if(debuginfo.debuging){
	axios.defaults.baseURL = 'http://yk.ioccn.at/';
}else{
	axios.defaults.baseURL = 'https://ykauth.ioccn.com/';
}
// axios.defaults.baseURL = 'http://192.168.0.166:8080/';

import mui from './assets/mui/js/mui.js'
import './assets/mui/css/xiug.css'
import './assets/mui/css/proxy.css'
import './assets/mui/css/mui.showLoading.css'
import './assets/mui/js/mui.showLoading.js'
import './assets/mui/css/mui.poppicker.css'
import './assets/mui/js/mui.poppicker.js'
import './assets/mui/css/mui.picker.css'
import './assets/mui/js/mui.picker.js'
import './assets/mui/js/mui.view.js'

const wx = {
	getStorageSync(key){
		return localStorage.getItem(key)
	},
	removeStorageSync(key){
		return localStorage.removeItem(key)
	},
	showToast(option){
		if(typeof option == 'string'){
			Toast.text({
				duration: 1000,
				message: option
			})
		}else{
			Toast.text({
				duration: 1000,
				message: option.title
			})
		}
	},
	showLoading(txt){
		if(typeof txt == 'object'){
			txt = txt.title
		}
		Toast.loading({
			message:txt ? txt : '加载中',
			duration:1000000
		})
	},
	hideLoading(){
		Toast.loading({
			message:'',
			duration:100
		})
	},
	showModal(option){
		Dialog.confirm({
			title: option.title,
			message: option.content,
			skin,
			showCancelButton: true
		}).then(() => {
			if(typeof option.success == 'function'){
				console.log(option.success)
				option.success.call(this,{
					confirm:true
				})
			}
		}).catch(() => {
			if(typeof option.success == 'function'){
				option.success.call(this,{
					confirm:false
				})
			}
		})
	},
	navigateTo(option){
			console.log('跳转链接')
		router.push(option.url)
	},
	redirectTo(option){
			console.log('跳转链接')
		router.push(option.url)
	},
	navigateBack(){
		router.back(-1)
	},
	requestPayment(params){
		var that = this;
		return new Promise((resolve, reject) => {
			try{
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', params,
					function(res){
						if(res.err_msg == "get_brand_wcpay_request:ok" ){
							resolve({});
						}else{
							reject(res);
						}
					}
				);
			}catch(e){
				reject(e);
			}
		});
	},
	getUrls(){
		var url = '';
		if(store.state.config.jtype){
			url = store.state.config.starturl;
		}else{
			url = window.location.href;
		}
		return url;
	}
};

/*if (typeof WeixinJSBridge === "undefined"){
	if (document.addEventListener){
		document.addEventListener('WeixinJSBridgeReady', function(){
			alert(typeof WeixinJSBridge);
			WeixinJSBridge.call('hideOptionMenu');
		}, false);
	}
}else{
	alert('bridge notloaded');
}*/

Vue.use(VueResource)
Vue.use(Vuex)
Vue.config.productionTip = false
Vue.prototype.$https = axios
Vue.prototype.$qs = qs
Vue.prototype.$wx = wx
Vue.prototype.$dayjs = dayjs
Vue.prototype.$query = query
Vue.prototype.$cookies = Cookies

Vue.prototype.$debug = debuginfo

const errorHandler = (error, vm)=>{
  console.log('抛出全局异常');
  console.log(vm);
  console.log(error);
  app.pr('/api/logs/post.html',{
	error:encodeURI(error),
	url:wx.getUrls()
  });
}
Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error)=> errorHandler(error,this);

const app = {
	r(url,params,succFunc,failFunc){
		var p = {
			token:store.state.token
		};
		if(params){
			for(var n in params){
				p[n] = params[n];
			}
		}
		Vue.prototype.$https.post(url, Vue.prototype.$qs.stringify(p)).then((res) => {
			if(typeof succFunc == 'function'){
				succFunc.call(this,res.data)
			}
		}).catch((res) => {
			if(typeof failFunc == 'function'){
				failFunc.call(this,res)
			}else{
				Toast.text({
					duration: 1000,
					message: res
				})
			}
		})
	},
	pr(url,params){
		var that = this;
		return new Promise((resolve, reject) => {
			this.r(url,params,function(res){
				resolve(res);
			},function(res){
				reject(res);
			})
		});
	},
	eventAudioList:{
		ended:[]
	},
	addAudioEvent(event,callback){
		if(event == 'ended'){
			this.eventAudioList.ended.push(callback);
			$('audio')[0].addEventListener('ended',callback);
		}
	},
	clearAudioEvent(event){
		for(var n in this.eventAudioList.ended){
			$('audio')[0].removeEventListener('ended',this.eventAudioList.ended[n]);
		}
		this.eventAudioList.ended = [];
	},
	audio:{
		vplaypause(){
			$('audio')[0].pause()
		},
		vplaypauseplay(){
			console.log($('audio')[0].src);
			$('audio')[0].play()
		},
		vplaystop(){
			$('audio')[0].src = 'http://jk.ioccn.com/k.mp3'
		},
		stop(){
			this.vplaystop()
		},
		play(string,callback){
			if($('audio').attr('src').indexOf('k.mp3') != -1){
				$('audio')[0].play()
			}
			var p = {
				token:store.state.token,
				text:string
			};
			Vue.prototype.$https.post('/api/common/voice.html', Vue.prototype.$qs.stringify(p)).then((res) => {
				//$('audio')[0].addEventListener('ended',callback);
				Vue.prototype.$app.clearAudioEvent('ended');
				Vue.prototype.$app.addAudioEvent('ended',callback);
		    	$('audio').attr('src',res.data.data)[0].play()
				console.log($('audio')[0].src);
			}).catch((res) => {
				Toast.text({
					duration: 1000,
					message: res
				})
			})
		},
		vplay(string,callback){
			this.play(string,callback)
		},
		bplay(string,callback){
			this.play(string,callback)
		},
	},
	IdentityCodeValid:function(code) {
		var city= { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
		var tip = "";
		var pass= true;

		if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)){
			tip = "身份证号格式错误";
			pass = false;
		}else if (!city[code.substr(0, 2)]) {
			tip = "地址编码错误";
			pass = false;
		} else {
			//18位身份证需要验证最后一位校验位
			if (code.length == 18) {
				code = code.split('');
				//∑(ai×Wi)(mod 11)
				//加权因子
				var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
				//校验位
				var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
				var sum = 0;
				var ai = 0;
				var wi = 0;
				for (var i = 0; i < 17; i++) {
				  ai = code[i];
				  wi = factor[i];
				  sum += ai * wi;
				}
				var last = parity[sum % 11];
				if (parity[sum % 11] != code[17]) {
				  tip = "校验位错误";
				  pass = false;
				}
			}
		}
		return pass;
	},
	locationAddress:false,
	locationAddressDetail:[],
	locationAddressed:false,
	getCurrentPosition(){
		var that = this;
		return new Promise((resolve, reject) => {
			if(that.locationAddressed){
				resolve(that.locationAddress)
			}else{
				reject({
					msg:'定位失败'
				});
				return false;
				wx.showLoading('正在获取位置')
				try{
					var geolocation = new BMap.Geolocation();
					geolocation.getCurrentPosition(function(r){
						wx.hideLoading()
						if(this.getStatus() == BMAP_STATUS_SUCCESS){
							that.locationAddress = JSON.stringify({
								location:{
									latitude:r.point.lat,
									longitude:r.point.lng
								}
							});
							that.locationAddressed = true;
							resolve(that.locationAddress)
							//alert('您的位置：'+r.point.lng+','+r.point.lat);
						}else {
							reject({
								msg:'定位失败'
							})
						}
					});
					/*navigator.geolocation.getCurrentPosition(function(position){
						wx.hideLoading()
						that.locationAddress = position;
						that.locationAddressed = true;
						resolve(that.locationAddress)
					},function(){
						wx.hideLoading()
						reject({
							msg:'定位失败'
						})
					},{
						enableHighAccuracy: false,
						timeout: 5000,
						maximumAge: 60000
					});*/
				}catch(e){
					alert(e);
				}
			}
		});
	},
	reloadUser(){
		this.pr('/api/user/info.html').then((res) => {
			res.data.unid = res.data.id;
			store.state.userInfo = res.data;
		},(res) => {
			console.log(res)
		})
	},
  goTo (url, p = {}) {//跳转 带参数
    router.push({path: url, query: p})
  },
  goBack(){
	router.back(-1)
  },
  getParam (key) {//获取参数
    var options = router.app._route.query
    return options[key]
  }
};

Vue.prototype.$app = app
Vue.prototype.$nav = {
	title:'',
	show:false
};
router.beforeEach((to, from, next) => {
	Vue.prototype.$nav.show = false;
	if(to.path == '/collection'){
		Vue.prototype.$nav.title = '错题收藏';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/mine'){
		Vue.prototype.$nav.title = '我的';
		Vue.prototype.$nav.show = false;
	}
	if(to.path == '/' || to.path == '/index' || to.path == '/indexnew' || to.path == '/video'){
		Vue.prototype.$nav.title = '首页';
		Vue.prototype.$nav.show = false;
	}
	if(to.path == '/video' || to.path == '/videodetail'){
		Vue.prototype.$nav.title = '考场视频';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/videocourse'){
		Vue.prototype.$nav.title = '视频课程';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/chapter'){
		Vue.prototype.$nav.title = '章节练习';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/learn'){
		Vue.prototype.$nav.title = '精选题';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/compensate'){
		Vue.prototype.$nav.title = '科目一保过卡';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/vip' || to.path == '/videovip'){
		Vue.prototype.$nav.title = '开通VIP';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/profile'){
		Vue.prototype.$nav.title = '个人资料';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/orders'){
		Vue.prototype.$nav.title = '我的订单';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/integral'){
		Vue.prototype.$nav.title = '积分记录';
		Vue.prototype.$nav.show = true;
	}
	if(to.path == '/wrong'){
		Vue.prototype.$nav.title = '错题收藏';
		Vue.prototype.$nav.show = true;
	}
	next();
});

const store = new Vuex.Store({
	state:{
		config:{
			webdomain:location.href.indexOf('jk.') == -1 ? (location.href.indexOf('test.') == -1 ? 'http://localhost:8082' : 'https://test.yxjk888.com') : 'https://jk.ioccn.com',
			domain:axios.defaults.baseURL,
			data:null
		},
		userInfo:{
			unid:null
		}
	}
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  qs,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js